$(document).ready(function () {
  $(".loader__wrapper-one").addClass("active");
});

$(window).on("load", function () {
  $(".loader").addClass("end");
});

// ========== Sticky Header Start ==============
const headerNew = document.querySelector('.header');
window.addEventListener("scroll", () => {
  if (window.scrollY > 20) {
    headerNew.classList.add("sticky");
  } else {
    headerNew.classList.remove("sticky");
  }
});

// ========== Sticky Header End ==============

//====== Active Page Link start ======
const windowPathname = window.location.pathname;
const navLinks = document.querySelectorAll(".header__navLink");
navLinks.forEach(link =>{
  const navLinkPathname = new URL(link.href).pathname;
  if((windowPathname === navLinkPathname) || (windowPathname === "/index.html" && navLinkPathname === "/")){
    link.classList.add("active");
  }
});
//====== Active Page Link end ======

/* ========== sidebar navigation toggle  =========*/
var closeMenuBtn = document.getElementById("close-menu-btn");
var mobileMenu = document.getElementById("mobile-menu");
var navbarToggle = document.getElementById("navbar-toggle");
var mobileMenuOverlay = document.getElementById("mobile-menu-overlay");
var body = document.querySelector(".yh-body");

navbarToggle.onclick = function () {
  mobileMenu.classList.add("is-active");
  mobileMenuOverlay.classList.add("is-active");
  body.classList.add("disable-scroll");
};

closeMenuBtn.onclick = function () {
  mobileMenu.classList.remove("is-active");
  mobileMenuOverlay.classList.remove("is-active");
  body.classList.remove("disable-scroll");
};


const playBtns = document.querySelectorAll(".video-action-btn");
if(playBtns !== null) {
  const videoContainer = document.querySelector(".video__popup-container");
  const videoOverlay = document.querySelector(".video__popup-overlay");
  const html = document.querySelector("html");
  const closeBtn = document.querySelector(".video__popup-close");
  let iframe = document.querySelector(".video__popup-iframe-container > iframe");

  playBtns.forEach((playBtn, index) => {
    playBtn.addEventListener("click",() => {
      const videoId = playBtn.dataset.id;
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      videoContainer.classList.add("show");
      videoOverlay.classList.add("overlay-show");
      html.classList.add("overflow-hidden");
    })
  });

  function hideVideo(){
    iframe.src ="";
    videoContainer.classList.remove("show");
    videoOverlay.classList.remove("overlay-show");
    html.classList.remove("overflow-hidden");
  }
  if(closeBtn !== null){
    closeBtn.addEventListener("click", hideVideo);
  }
  if(closeBtn !== null){
    videoOverlay.addEventListener("click", hideVideo);
  }
}
// ============== cursor view case =====================
const cursorBee = document.querySelector(".cursor-bee");
const cursorEye = document.querySelector(".cursor-eye");
let scale = 1;

function mousemoveHandler(e) {
  const target = e.target;
  const tl = gsap.timeline({
    defaults: {
      x: e.clientX,
      y: e.clientY,
      ease: "power2.out",
    },
  });

  if (target.tagName.toLowerCase() === "img" && target.closest(".image-grid")) {
    tl.to(cursorBee, {
      opacity: 0,
    }).to(
      cursorEye,
      {
        opacity: 1,
        zIndex: 5,
      },
      "-=0.5"
    );
  } else {
    if (target.classList.contains("line-animation")) {
      scale = 4;
    } else {
      scale = 1;
    }

    tl.to(cursorBee, {
      opacity: 1,
      scale: scale,
    }).to(
      cursorEye,
      {
        opacity: 0,
      },
      "-=0.5"
    );
  }
}

function mouseleaveHandler() {
  gsap.to(cursorBee, {
    opacity: 0,
  });
}

document.addEventListener("mousemove", mousemoveHandler);
document.addEventListener("mouseleave", mouseleaveHandler);

// ================= faq (accordion) section ===============
const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");
    let content = this.nextElementSibling;
    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});


// ============= video scale gsap animation starts =========
gsap.registerPlugin(ScrollTrigger);
const tl = gsap.timeline();

// ========== text and hero animation =========
window.addEventListener("load", () => {
  // hero area
  tl.from(".header__logo", 1, {
    opacity: 0,
    y: -50,
    delay: 1,
    ease: Expo.easeInOut,
  });

  tl.from(".navbar-toggle", 1, {
    opacity: 0,
    y: -100,
    delay: -1,
    ease: Expo.easeInOut,
  });

  tl.from(".animate-hero-heading", {
    opacity: 0,
    duration: 1.2,
    y: 50,
    delay: -1.8,
    ease: Power3.easeInOut,
  });

  tl.from(".moving-logo__wrapper", {
    opacity: 0,
    scale: 0.9,
    ease: Power3.easeInOut,
    delay: -0.45,
  });

  tl.from(".banner-social-media__list-item", {
    opacity: 0,
    ease: Power3.easeInOut,
    stagger: 0.1,
    delay: -0.7,
    x: -20,
  });

  tl.from(".contact-form__social-media > .social-media-link", {
    opacity: 0,
    ease: Power3.easeInOut,
    stagger: 0.1,
    delay: -0.7,
    x: -20,
  });

  // about page animation
  tl.from(".hero__header", {
    opacity: 0,
    duration: 1.2,
    y: 50,
    delay: -0.5,
    ease: Power3.easeInOut,
  });

  tl.from(".animate-hero-image", 1, {
    opacity: 0,
    duration: 2.8,
    y: 30,
    delay: -2.3,
    ease: Power3.easeInOut,
  });

  tl.from(".animate--branding-hero-image", 1, {
    opacity: 0,
    duration: 2,
    y: 30,
    delay: -2.3,
    stagger: 0.1,
    ease: Power3.easeInOut,
  });
});

// animation on text container
const textContainers = gsap.utils.toArray(".animate-fade-in-up");
textContainers.forEach((textContainer, i) => {
  const anim = gsap.fromTo(
    textContainer,
    { opacity: 0, y: 50 },
    { duration: 1, opacity: 1, y: 0 }
  );
  ScrollTrigger.create({
    trigger: textContainer,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1,
    ease: Power4.easeOut,
  });
});

// animation of fade in for hero part
const fadeIn = gsap.utils.toArray(".animate-fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(
    mainContent,
    { opacity: 0 },
    { duration: 1, opacity: 1, stagger: 0.2 }
  );
  ScrollTrigger.create({
    trigger: mainContent,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1,
    ease: Power4.easeOut,
  });
});

// animate the about us gallery 
const aboutGallery = gsap.utils.toArray(".animate-about-gallery");

aboutGallery.forEach((imageItem, i) => {
  const anim = gsap.from(
    imageItem,
    { opacity: 0, y: 30,  }
  );
  ScrollTrigger.create({
    trigger: imageItem,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 2.6,
    delay:1,
    stagger:0.2,
    ease: Power3.easeInOut,
  });
});

// animation on images
const images = gsap.utils.toArray(".animate-image-revel");
images.forEach((image, i) => {
  const animImage = gsap.from(image, {
    y: 30,
    opacity: 0.65,
    duration: 1,
  });
  ScrollTrigger.create({
    trigger: image,
    animation: animImage,
    toggleActions: "play",
    once: true,
    duration: 1,
    ease: Power4.easeOut,
  });
});


// ============ javascript counter =============
function visible(partial) {
  let $t = partial,
    $w = jQuery(window),
    viewTop = $w.scrollTop(),
    viewBottom = viewTop + $w.height(),
    _top = $t.offset().top,
    _bottom = _top + $t.height(),
    compareTop = partial === true ? _bottom : _top,
    compareBottom = partial === true ? _top : _bottom;

  return (
    compareBottom <= viewBottom && compareTop >= viewTop && $t.is(":visible")
  );
}

$(window).scroll(function () {
  const myCounter = document.querySelector('.count-digit');

  if (myCounter !== null) {
    if (visible($(".count-digit"))) {
      if ($(".count-digit").hasClass("counter-loaded")) return;
      $(".count-digit").addClass("counter-loaded");

      $(".count-digit").each(function () {
        if ($(this).html() == Math.floor($(this).html())) {
          var $this = $(this);
          jQuery({ Counter: 0 }).animate(
            { Counter: $this.text() },
            {
              duration: 1500,
              easing: "swing",
              step: function () {
                $this.text(Math.trunc(this.Counter) + 1);
              },
            }
          );
        } else {
          var $this = $(this);
          jQuery({ Counter: 0 }).animate(
            { Counter: $this.text() },
            {
              duration: 1500,
              easing: "swing",
              step: function () {
                $this.text(((this.Counter * 10) / 10).toFixed(1));
              },
            }
          );
        }
      });
    }
  }
});

// ============== checkbox is checked ============
$("#agree-concent").click(function () {
  if (!$(this).is(":checked")) {
    $("#btncheck").attr("disabled", "disabled").removeClass("enable");
  } else $("#btncheck").removeAttr("disabled").addClass("enable");
});

// =========== mobile menu animation ============
const navbarToggleItem = document.querySelector("#navbar-toggle");
const closeMenuBtnItem = document.querySelector("#close-menu-btn");
const mobileLinkList = document.querySelectorAll(".mobile-nav__list-item");
const mobileFooterLink = document.querySelectorAll(".mobile-menu__social-media-link");
const mobileNavTitle = document.querySelectorAll(".mobile-menu__nav-title");
const mobileLinkListArr  = Array.from(mobileLinkList);
const mobileNavLink = document.querySelectorAll(".mobile-nav__link");
const mobileNavLinkArr = Array.from(mobileNavLink);

navbarToggleItem.addEventListener("click", () => {
  tl.to(".mobile-menu", {
    opacity:1,
    y:0,
    duration:0.3,
    ease:Power4.easeInOut,
  })

  mobileNavTitle.forEach((title) => {
    gsap.fromTo(".mobile-menu__nav-title", {
      opacity:0,
    },
    {
      opacity:1,
      delay:0.3,
      duration:0.25,
      ease:Power4.easeInOut,
    })
  })

  mobileNavLinkArr.forEach((mobileLink) => {
    gsap.fromTo(".mobile-nav__link", {
      y:"100%",
      ease:Power4.easeInOut,
    }, 
    {
      y:0,
      duration:0.35,
      ease:Power4.easeInOut,
    })
  })

  mobileFooterLink.forEach((link) => {
    gsap.fromTo('.mobile-menu__social-media-link', {
      x:-20,
      opacity:0,
    },
    {
      x:0,
      opacity:1,
      stagger:0.1,
      ease:Power4.easeInOut,
    })
  })
})

closeMenuBtnItem.addEventListener("click", () => {
  mobileNavTitle.forEach((title) => {
    gsap.fromTo(".mobile-menu__nav-title", {
      opacity:1,
    },
    {
      opacity:0,
      duration:0.25,
      delay:0.3,
      ease:Power4.easeInOut,
    })
  })

  mobileNavLinkArr.forEach((mobileLink) => {
    gsap.fromTo(".mobile-nav__link",
    {
      y:0,
      ease:Power4.easeInOut,
    },
    {
      y:"100%",
      duration:0.65,
      ease:Power4.easeInOut,
    }
    )
  })

  mobileFooterLink.forEach((link) => {
    gsap.fromTo('.mobile-menu__social-media-link', {
      x:0,
      opacity:1,
      stagger:0.1,
    },
    {
      x:-20,
      opacity:0,
      delay:0.35,
      ease:Power4.easeInOut,
    })
  })

  tl.from(".mobile-menu", {
    opacity:0,
    duration:0.35,
    delay:0.5,
    ease:Power4.easeInOut,
  })
})